import React, { useCallback, useContext } from 'react';

import { ToastContext } from '@pflegia/ui/contexts/toast.context';

import ToastMessage, { ToastMessageProps } from './ToastMessage';
import { Toast } from './ToastProvider';

interface ToastContainerProps {
  list: Toast[];
}

const ToastContainer: React.FC<ToastContainerProps> = ({ list }) => {
  const context = useContext(ToastContext);

  const handleRemove = useCallback<NonNullable<ToastMessageProps['onRemove']>>(
    id => {
      context?.remove(id);
    },
    [context],
  );

  return list.length > 0 ? (
    <div
      className='z-toast fixed bottom-4 left-1/2 flex max-h-[calc(100vh-1rem)] w-full -translate-x-1/2 animate-[fade-in_300ms_forwards] flex-col gap-2 overflow-auto md:max-w-sm'
      data-testid='toast-container'>
      {list.map(toast => (
        <ToastMessage
          id={toast.id}
          key={toast.id}
          lifetime={toast.lifetime}
          message={toast.message}
          onRemove={handleRemove}
          variant={toast.type}
        />
      ))}
    </div>
  ) : null;
};

export default ToastContainer;
